// extracted by mini-css-extract-plugin
export default {"qr_popup":"styles_qr_popup__Zbq+X","desc":"styles_desc__Wdfos","close_btn":"styles_close_btn__PCLzy","dimmed_wrapper":"styles_dimmed_wrapper__g3-aR"};